import React, { useState } from 'react'
import { MessageWrapper, TextInput, ToolTip, FontBody } from '../index.styled';
import Typography from '../../Typography';
import { useTranslation } from 'react-i18next';

export const MessageArea = () =>{
  const { t } = useTranslation();
  const [showTip, setShowTip] = useState(false);

  const language = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';
  const emailError = (language === 'ja') ? '上限文字数半角1000文字に達しました。' : 'Maximum 1000 characters';

  const validate = (e) => {
    if (e.target.value.length >= 1000) {
      setShowTip(true)
    }else{
      setShowTip(false)
    }
  }

  return (
    <MessageWrapper>
      <FontBody>
        {
          showTip && (
            <ToolTip>{emailError}</ToolTip>
          )
        }
        <TextInput>
          <textarea maxLength={1000} onChange={e => validate(e)} title={'message'} name={'message'} placeholder={t('FormData.textAreaPlaceHolder')}></textarea>
        </TextInput>
      </FontBody>
    </MessageWrapper>
  )
}